import { render, staticRenderFns } from "./LivingOptionsSubsections.vue?vue&type=template&id=6dc27a06&scoped=true&"
import script from "./LivingOptionsSubsections.vue?vue&type=script&lang=js&"
export * from "./LivingOptionsSubsections.vue?vue&type=script&lang=js&"
import style0 from "./LivingOptionsSubsections.vue?vue&type=style&index=0&id=6dc27a06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc27a06",
  null
  
)

export default component.exports